/**
 * Telemetry event describing that the user has selected an 'application' filter
 * @type {string}
 */
export const APPLICATION_SELECTED_EVENT = 'application_selected';

/**
 * Cookie name for the Adobe Analytics Visitor Id
 * @type {string}
 */
export const ADOBE_ANALYTICS_VISITOR_ID_COOKIE = 's_ecid';

/**
 * Telemetry event describing that the user has clicked 'Additional Info' link
 * of an evaluation board item
 * @type {string}
 */
export const EVALUATION_BOARD_CLICK_EVENT = 'evaluation_board_click';

/**
 * Telemetry event describing the initial load of the app
 * @type {string}
 */
export const INITIAL_LOAD_EVENT = 'initial_load';

/**
 * Telemetry event describing that the user has clicked the 'Modify Design' link
 * @type {string}
 */
export const MODIFY_DESIGN_CLICK_EVENT = 'modify_design_click';

/**
 * Telemetry event describing that the user has selected an 'optimization' filter
 * @type {string}
 */
export const OPTIMIZATION_SELECTED_EVENT = 'optimization_selected';

/**
 * Telemetry event describing that the user has clicked the 'Product Selection Guide' link
 * @type {string}
 */
export const PRODUCT_SELECTION_GUIDE_CLICK_EVENT = 'product_selection_guide_click';

/**
 * Telemetry event describing that the user has clicked 'Additional Info' link
 * of a sample item
 * @type {string}
 */
export const SAMPLE_CLICK_EVENT = 'sample_click';

/**
 * Telemetry event describing that the user has selected a 'sensorType' filter
 * @type {string}
 */
export const SENSOR_SELECTED_EVENT = 'sensor_selected';

/**
 * Telemetry event describing that the user has clicked the 'Share Design' link
 * @type {string}
 */
export const SHARE_DESIGN_CLICK_EVENT = 'share_design_click';

/**
 * Telemetry event describing that the user has clicked the 'Simulation Files' link
 * @type {string}
 */
export const SIMULATION_FILE_DOWNLOAD_CLICK_EVENT = 'simulation_file_download_click';

/**
 * Telemetry event describing that the user has clicked one of 'Schematic',
 * 'Evaluation Kits' and 'Samples' tab
 * @type {string}
 */
export const TAB_CLICK_EVENT = 'tab_click';

/**
 * Telemetry event describing that the user has viewed the app for atleast 2 seconds
 * @type {string}
 */
export const VIEWED_BY_USER_EVENT = 'viewed_by_user';
